
import '../leadScrutinizer/registrationLeadScrutiny.css'
import { useNavigate } from "react-router-dom";
import { GET_MAPPING_DETAILS,GET_MAPPING_DETAILS_PAGINATED } from '../../../common/URLs';
import React, { useState, useEffect } from "react";
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import Link from "@mui/material/Link";
import { lastFiveDigitsComparator } from '../../../common/commonFunction';
import apiClient from '../../../axios';
import CustomDataGridToolbarServer from '../../../common/customDataGridToolbarServer';

function ScrutinyDetails(props) {
    const [userId, setUserId] = useState(props.userid);
    const [mappingDetails, setMappingDetails] = useState();
    const navigate = useNavigate();
    useEffect(() => {
        if (props.userid) {
            getMappingDetails(page, pageSize, searchText);
        }
    }, [props.userid]);
    const [page, setPage] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(10);
    const [sortField, setSortField] = React.useState(null);
    const [sortOrder, setSortOrder] = React.useState(null);
    const [searchText, setSearchText] = React.useState("");
    const onView = (urnSelected, stakeholderType, growerSubCategory) => {
        const userData = {
            "urnSelected": urnSelected,
            "userId": userId,
            "isScrutinyView": true

        }
        if (stakeholderType === "Transporter") {
            navigate("/registrationHome/dashboard/registrationDetailsTransporter", { state: { data: userData, URN: urnSelected, viewOnly: true } });
        }
        else if (stakeholderType === "HIT") {
            navigate("/registrationHome/dashboard/registrationDetailsHit", { state: { data: userData, URN: urnSelected, viewOnly: true } });
        }
        else if (stakeholderType === "LLE") {
            navigate("/registrationHome/dashboard/registrationDetailsLle", { state: { data: userData, URN: urnSelected, viewOnly: true } });
        }
        else if (stakeholderType === "Interim Storage Operator") {
            navigate("/registrationHome/dashboard/registrationDetailsTempStorage", { state: { data: userData, URN: urnSelected, viewOnly: true } });
        }
        else if (growerSubCategory == "Individual" || growerSubCategory == "JFMC" || growerSubCategory === "Other Agency") {
            navigate("/registrationHome/dashboard/registrationDetails", { state: { data: userData, URN: urnSelected, viewOnly: true } });
        }
        else if (growerSubCategory === "Co-operative" || growerSubCategory === "FPO" || growerSubCategory === "SHG" || growerSubCategory === "FPC") {
            navigate("/registrationHome/dashboard/registrationMemberDetails", { state: { data: userData, URN: urnSelected, viewOnly: true } });
        }
        else if (growerSubCategory === "Forest") {
            navigate("/registrationHome/dashboard/registrationDetailsForest", { state: { data: userData, URN: urnSelected, viewOnly: true } });
        }
        else {
            // navigate("/registrationHome/dashboard/onView", { state: { data: userData } });
        }
    }
    const getMappingDetails = async (pageNo = 0, pageSize = 10, searchText = "", isExport = false, sortColumn = "LastUpdatedDate", sortDirection = "desc") =>{
            loaderService.showLoader();
           let response = await apiClient
              .post(GET_MAPPING_DETAILS_PAGINATED,
                  {
                      "userID": props.userid,
                      "userRole": props.role,
                      "pageNumber": pageNo,
                      "pageSize": pageSize,
                      "sortColumn": sortColumn ? sortColumn : "LastUpdatedDate",
                      "sortDirection": sortDirection ? sortDirection:"desc" ,
                      "filterText": searchText
                  },
                  {
                      headers: {
                          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                      }
                  }, null
        );
        loaderService.hideLoader();
        if (isExport)
         {
                  return response?.data?.scrutinizermappings;
         }
        else
        {
            setMappingDetails(response.data);
        }
      }

    const handleSortModelChange = async (model) => {
        console.log(model[0]?.field);
        console.log(model[0]?.sort);
        setSortField(model[0]?.field);
        setSortOrder(model[0]?.sort);
        await getMappingDetails(page, pageSize, searchText, false, model[0]?.field, model[0]?.sort);
    }
    const fetchSearchData =async (searchInput) => {
        setSearchText(searchInput);
        await getMappingDetails(page, pageSize, searchInput, false, sortField, sortOrder);
    };
    const fetchData = async() => {
        return await getMappingDetails(0, 0, searchText, true, sortField, sortOrder);
    }

    const columns = [
        {
            field: 'id', headerName: 'S.No', width: 60,
            renderCell: (index) => index.api.getRowIndex(index.row?.workflowMasterID) + 1
        },
        { field: 'scrutinizerName', headerName: 'Scrutinizer', width: 200 },
        { field: 'urn', headerName: 'URN', width: 200, renderCell: (params) => { return (<Link to={params} onClick={() => { onView(params?.row?.urn, params?.row?.stakeholderType, params?.row?.stakeholderSubCategory) }}>{params.value}</Link>) } },
        { field: 'stakeholderName', headerName: 'Stakeholder Name', width: 200 },
        { field: 'mobileNumber', headerName: 'Mobile Number', width: 200 },
        { field: 'address', headerName: 'Address', width: 200 },
        { field: 'district', headerName: 'District', width: 200 },
        { field: 'stakeholderType', headerName: 'Stakeholder Type', width: 200 },
        {
            field: 'isRegistered', headerName: 'Reg. Completed', width: 200,
            valueFormatter: (params) => {
                if (params.value === true) {
                    return 'Yes';
                }
                else {
                    return 'No';
                }
            }
        },
        { field: 'curentOwner', headerName: 'Current Owner', width: 200 },
        { field: 'status', headerName: 'Status', width: 200 },
        { field: 'scrutinyStatus', headerName: 'Scrutiny Status', width: 200 },
        { field: 'lastUpdatedDate', headerName: 'Last Updated Date', width: 200 },
        { field: 'preRegDate', headerName: 'Pre Registration Date', width: 200 },
        { field: 'shortlistDate', headerName: 'Shortlisted Date', width: 200 },
        { field: 'registrationDate', headerName: 'Registration Date', width: 200 },
        { field: 'scrutinyStartDate', headerName: 'Scrutiny Start Date', width: 200 },
        { field: 'totalQuantity', headerName: 'Total Quantity (in MT)', width: 140, type: "number" },
        { field: 'committedQuantity', headerName: 'Committed Quantity (in MT)', width: 140, type: "number" },
    ];

    return (
        <>
            <div style={{ display: "inline-flex" }}>
                <div className="hitDetailsText">Mapping Details</div>
            </div>
            {mappingDetails?.scrutinizermappings &&
                <Box style={{ height: 500, width: '100%' }}>
                    <DataGrid
                        sx={{
                            "& .MuiDataGrid-columnHeaderTitle": {
                                whiteSpace: "normal",
                                lineHeight: "normal"
                            },
                            "& .MuiDataGrid-columnHeader": {
                                height: "unset !important"
                            },
                            "& .MuiDataGrid-columnHeaders": {
                                maxHeight: "168px !important"
                            }
                        }}
                        rows={mappingDetails?.scrutinizermappings}
                        columns={columns}
                        getRowId={(row) => row?.workflowMasterID}
                        paginationMode="server"
                        rowCount={mappingDetails?.totalCount}
                        rowsPerPageOptions={[10, 20, 50, 100]}
                        page={page}
                        pageSize={pageSize}
                        onPageChange={(newPage) => { setPage(newPage); getMappingDetails(newPage, pageSize, searchText, false, sortField, sortOrder) }}
                        onPageSizeChange={(newPageSize) => { setPageSize(newPageSize); getMappingDetails(page, newPageSize, searchText, false, sortField, sortOrder) }}
                        sortingMode="server"
                        onSortModelChange={handleSortModelChange}
                        components={{ Toolbar: CustomDataGridToolbarServer }}
                        componentsProps={{ toolbar: { columns: columns, onSearch: fetchSearchData, onFetchData: fetchData, fileName: "StakeholderMapping.xlsx", dateFields: [ 'lastUpdatedDate', 'preRegDate', 'shortlistDate', 'registrationDate', 'scrutinyStartDate'] } }}
                    />
                </Box>}

        </>

    )
}

export default ScrutinyDetails;
